<template>
  <v-dialog v-model="open" max-width="50vw" @click:outside="() => $emit('exit')">
    <v-card class="mx-auto set-layout">
      <!-- <v-card-title class="headline" style="height:10%">Firmware Update</v-card-title> -->
      <v-row>
        <v-col cols="4">
          <div class="org-select-item">
            <span class="label">Organisation</span>
            <v-autocomplete
              v-model="org"
              label="Select Organisation"
              :items="sortedOrgs"
              item-text="name"
              item-value="id"
              :item-disabled="(j) => j.disabled === 'True'"
              style="height:10%"
              solo
              required
            ></v-autocomplete>
          </div>
        </v-col>

        <v-col cols="4">
          <div class="org-select-item">
            <span class="label">Filter by Model</span>
            <v-autocomplete
              v-model="selectedModel"
              label="Filter by Model"
              :items="deviceModels"
              style="height:10%"
              solo
              required
            />
          </div>
        </v-col>
      </v-row>
      
      <v-container fluid style="height:80%">
        <v-row justify="space-between" align="center" class="fill-height">
          <v-col cols="5" class="fill-height">
            <v-text-field
              v-if="org"
              v-model="search"
              label="Search Vehicles"
              prepend-icon="mdi-magnify"
            ></v-text-field>
            <v-card class="transfer-source mx-auto" outlined tile>
              <div class="fill-height">
                <v-progress-circular
                  v-if="loader"
                  :size="50"
                  color="secondary"
                  class="progress-circular-absolute"
                  indeterminate
                ></v-progress-circular>
                <v-list class="fill-height pa-0">
                  <v-list-item-group v-model="selectedVehicles" multiple class="fill-height vehicle-list-scroll">
                    <template v-for="(car, j) in filteredVehicles">
                      <v-list-item :key="'vehi' + j" :value="car" active-class="third--text">
                        <template>
                          <v-list-item-icon>
                            <v-icon>mdi-car</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title v-text="car.vehicle_name"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </div>
            </v-card>
          </v-col>
          <v-col cols="2" class="d-flex fill-height align-center justify-center flex-column text-center">
            <v-btn :disabled="selectedVehicles.length < 1" class="ma-2" outlined large fab color="third" @click="assign">
              <v-icon>mdi-chevron-double-right</v-icon>
            </v-btn>
            <v-btn :disabled="selectedDevices.length < 1" class="ma-2" outlined large fab color="third" @click="unassign">
              <v-icon>mdi-chevron-double-left</v-icon>
            </v-btn>
            <v-btn :disabled="!(org && vehicles.length > 0)" class="ma-2" outlined large fab color="warning" @click="assignAll">
              <v-icon>mdi-chevron-triple-right</v-icon>
            </v-btn>
            <v-btn :disabled="!(org && vehicles.length > 0)" class="ma-2" outlined large fab color="warning" @click="deselectAll">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="5" class="fill-height">
            <v-card class="mx-auto pa-2 transfer-target" outlined tile>
              <v-subheader>Target Devices</v-subheader>
              <div class="fill-height">
                <v-list class="pa-0 devices-scroll">
                  <v-list-item-group v-model="selectedDevices" multiple>
                    <template v-for="device in devices">
                      <v-list-item :key="device.id" :value="device" active-class="third--text">
                        <template>
                          <v-list-item-content>
                            <v-list-item-title v-text="device.vehicle_name"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </div>
              <span class="pt-0">Total Devices: {{ devices.length }}</span>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="confirm">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { GetOrgVehicles } from "@/services/API.js"
import { mapState } from "vuex"

import { Logger } from "aws-amplify"
const logger = new Logger("TransferReverse")

export default {
  name: 'TransferReverse',
  props: {
    open: {
      required: true,
      type: Boolean,
    },
    value: {
      required: true,
      type: Array,
    },
  },
  data: () => ({
    selectedDevices: [],
    selectedVehicles: [],
    org: null,
    vehicles: [],
    devices: [],
    loader: false,
    search: '',
    deviceModels: ['All'],
    selectedModel: 'All',
    items: [],
    AI_DVR: 'CAMERAMATICS_JHX_NT'
  }),
  computed: {
    ...mapState(["orgs"]),
    sortedOrgs() {
      return [...this.orgs].sort((a, b) => a.name.localeCompare(b.name));
    },
    filteredVehicles() {
      if (this.search.length > 0) {
        let filteredItems = this.vehicles.filter(item => {
          return item.vehicle_name.toLowerCase().includes(this.search.toLowerCase());
        });

        return filteredItems;
      } 
      else {
        if (this.selectedModel != 'All' && this.selectedModel != this.AI_DVR) {
          logger.info('filter is not all')
          let filteredItems = this.vehicles.filter((vehicle) => {
            return vehicle.devices.some(device => {
              return device.model === this.selectedModel;
            });
          });

          return filteredItems;
        } 
        else if (this.selectedModel == this.AI_DVR) {
          logger.info('testing ', this.selectedModel)
          let filteredItems = this.vehicles.filter((vehicle) => {
            return vehicle.devices.some(device => {
              return device.model.includes('_NT');
            });
          });

          return filteredItems;
        }
        else {
          return this.vehicles;
        } 
      }
    }
  },
  watch: {
    org(val) {
      if (val) {
        this.getOrgVehicles(val)
      }
    },
    open(val) {
      if (val) {
        this.devices = this.value
      }
    },
    devices(val) {
      if (val) {
        this.$emit("input", this.devices)
      }
    },
    selectedModel(val) {
      logger.info('selectedModel ', val)
    }
  },
  methods: {
    compileDeviceModels() {
      this.vehicles.forEach(vehicle => {
        vehicle.devices.forEach(device => {
          if (device.model) {
            if (!this.deviceModels.includes(device.model)) {
              this.deviceModels.push(device.model);
            }
            this.selectedModel = this.deviceModels[0];

            // Check for AI DVR, 4 or 8 channel
            if (device && device.model.includes('_NT')) {
              this.deviceModels.push(this.AI_DVR);
            }
          }
        });
      });
    },
    deselectAll() {
      logger.info('deselect all ')
      this.selectedVehicles = [];
      this.selectedDevices = [];
      this.devices = [];
    },
    assign() {
      this.devices = this.devices.concat(this.selectedVehicles.filter((vehi) => !this.devices.map((dev) => dev.id).includes(vehi.id)))
      this.selectedVehicles = []
    },
    unassign() {
      this.devices = this.devices.filter((vehi) => !this.selectedDevices.map((dev) => dev.id).includes(vehi.id))
      this.selectedDevices = []
    },
    assignAll() {
      this.devices = this.devices.concat(this.filteredVehicles.filter((vehi) => !this.devices.map((dev) => dev.id).includes(vehi.id)))
      this.selectedVehicles = []
    },
    async getOrgVehicles(org) {
      this.loader = true
      const res = await GetOrgVehicles(org, true)
      if (res) {
        this.vehicles = res.filter((car) => car.devices && car.devices.length > 0);
        this.compileDeviceModels();
      }
      this.loader = false
    },
    confirm() {
      this.$emit("exit")
    },
  },
}
</script>

<style lang="scss" scoped>
.transfer-source {
  height: 90%;
}
.vehicle-list-scroll {
  overflow-x: hidden;
  overflow-y: auto;
}
.transfer-target {
  height: 100%;
  .devices-scroll {
    height: calc(100% - 48px);
    overflow: auto;
  }
}
.org-select-item {
  padding: 0 1em 0 1em;
  .label {
    font-size: 13px;
  }
}

.set-layout {
  height: 85vh;
  width: 50vw;
  overflow-x: hidden;
}
</style>
